export default "__VITE_ASSET__DmKmJqin__"